import { useTranslate } from '@refinedev/core';
import React from 'react';
import useStyles from './loggedOutFooter.style';

export const CcLoggedOutFooter: React.FC = () => {
  const translate = useTranslate();
  const { styles } = useStyles();
  return (
    <footer>
      <div className={styles.footerContainer}>
        <div>
          <a
            href="https://copingcard.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            {translate('screens.privacy')}
          </a>
        </div>
        <div>
          <a
            href="https://copingcard.com/terms"
            target="_blank"
            rel="noopener noreferrer"
          >
            {translate('screens.terms')}
          </a>
        </div>
        <div>{translate('pages.login.copywrite')}</div>
      </div>
    </footer>
  );
};
